<template>
	<div  class="visual_wrap" id='visual_wrap'>
        <div class="toolsbar">
            <el-row>
                <el-button icon="el-icon-plus" circle  @click="NewLine"></el-button>
                <el-button type="primary" icon="el-icon-edit" circle   @click="editMode"></el-button>
                <el-button type="primary" icon="el-icon-check" circle   @click="AddContent"></el-button>
                <el-button type="success" icon="el-icon-check" circle @click="AddAffix"></el-button>
                <el-button type="info" icon="el-icon-message" circle></el-button>
                <el-button type="warning" icon="el-icon-star-off" circle></el-button>
                <el-button type="danger" icon="el-icon-delete" circle></el-button>

                <el-button type="primary" style="margin-right:30px;margin-left:30px" @click="ConfirmNewLine">确定</el-button>
                <el-button type="info" @click="CancleNewLine">取消</el-button>
                    
            </el-row>
            <!-- <div  class="btn_bar">
                <el-button type="primary" style="margin-right:30px" @click="ConfirmNewLine">确定</el-button>
                <el-button type="info" @click="CancleNewLine">取消</el-button>
            </div> -->
        </div>
        <div class="canvas">
            <div class="left_devide"></div>

            <!-- 新行 -->
            <!-- <div class="timeline" v-if="isNewCase">
                <div class="l_part">
                   <div style="padding-right:10px">  
                        <el-date-picker
                            v-model="newCase.timestamp"
                            value-format='timestamp'
                            type="date"
                            placeholder="选择日期">
                        </el-date-picker>

                   </div>
                </div>

                <div class="r_part">  
                    <div class="txt_node" style="padding-left:10px"> 
                        <el-input
                            type="textarea"
                            style="width:90%"
                            :rows="2"
                            placeholder="请输入内容"
                            v-model="newCase.title">
                        </el-input>

                    </div>

                    <div class="txt_node" style="padding-left:10px"> 
                        <el-input
                            type="textarea"
                            style="width:90%"
                            :rows="3"
                            :max='10000'
                            placeholder="请输入详情"
                            v-model="newCase.content">
                        </el-input>

                    </div>

                    <affix_box  style="margin-top:10px" :isEdit="true"  :affixfileList="param.fileList"> </affix_box>



                    <div  class="btn_bar">
                        <el-button type="primary" style="margin-right:30px" @click="ConfirmNewLine">确定</el-button>
                        <el-button type="info" @click="CancleNewLine">取消</el-button>
                    </div>


                </div>

            </div> -->

            <!-- 新行 end  -->

            <div class="timeline" v-for="(item,index) of cases"   :key="index"   @click="ChooseItem(index)"> 
               
               
                <div class="l_part">
                    <div class="l_part_up">
                        <div v-if="currentIndex==index">  
                            <img src="@/assets/images/bluedot.png" class="bluespot" style="margin-right:20px" alt="">
                        </div>
                    

                        <div  v-if="!isEdit" style="padding-right:10px"> {{timestampToTime(item.timestamp)}} </div>

                        <div v-else style="padding-right:10px">  
                            
                            <el-date-picker
                                v-model="item.timestamp"
                                value-format='timestamp'
                                type="date"
                                placeholder="选择日期">
                            </el-date-picker>

                        </div>


                    </div>
                    <div style="width:100%;z-index:1;">
                        <el-button type="text"   @click="DeleteLine" style="cursor:pointer; float:right;margin-right:15px"> 删除本段 </el-button>
                    </div>
                     
                 

                </div>

                <div class="r_part">  
                    <div v-if="!isEdit" class="txt_node" style="padding-left:10px"> {{item.title}} </div>
                    <div v-else class="txt_node" style="padding-left:10px"> 
                        <el-input
                            type="textarea"
                            style="width:90%; font-size: 20px; font-weight:bold"
                            :rows="2"
                            placeholder="请输入内容"
                            v-model="item.title">
                        </el-input>

                       

                    </div>

 
                    
                    <div  class="subtxt_node" v-if="!isEdit && item.attr.content">
                        {{item.content}}
                    </div>    
 
                    <div class="subtxt_node" v-if="isEdit && item.attr.content"  style="padding-left:10px"> 
                        <el-input
                            type="textarea"
                            style="width:90%;  font-size: 17px;"
                          
                            :autosize="{ minRows: 3, maxRows: 5}"
                            placeholder="请输入详情"
                            v-model="item.content"> 
                        </el-input>

                        <i class="el-icon-circle-close" v-if="currentIndex==index"  @click="DeleteModule('content')" style="margin-left:10px;cursor:pointer"></i>

                    </div>

                    <div class="affix_node" style="padding-left:10px;margin-bottom:10px"  v-if="  item.attr.affix"  > 
                        <affix_box :isEdit="isEdit"  :affixfileList="item.affix" style="width:90%"> </affix_box>
                        <i class="el-icon-circle-close" v-if="currentIndex==index"  @click="DeleteModule('affix')" style="margin-left:10px;cursor:pointer"></i>


                    </div>
                  

                    <!-- <div class="txt_node" style="padding-left:10px"> 
                        <el-input
                            type="textarea"
                            style="width:90%"
                            :rows="2"
                            placeholder="请输入内容"
                            v-model="item.title">
                        </el-input>

                    </div> -->


                 


                </div>

            </div>

            

        

         
            <!-- <div class="timeline">
                <div class="l_part">
                   <div style="padding-right:10px"> 2023年9月30日</div>
                </div>
                <div class="r_part">

                    <el-form ref="form" :model="param" label-width="80px" class="form_wrap">
                        <div class="txt_node" style="padding-left:10px">签订《xxxx》合同</div>
                        <div class="subtxt_node">
                            da sda asd asd asdas as as das dd ad aas da s 12321sdad sa as收到按时阿达奥迪阿斯达是阿萨德奥术大师阿萨德奥术大师按时大师按时大师打
                        </div>  

                        <affix_box   :affixfileList="param.fileList"> </affix_box>
                        
                        <div class="contract_part">
                            <div  v-for="(item,index) of param.cond" v-bind:key="index">
                                <el-form-item :label="'支付节点'+(index+1)">
                                    <el-input v-model="item.event"></el-input>
                                </el-form-item>

                                <el-form-item label="日期">
                                    <el-col :span="11">
                                        <el-date-picker type="date" @change="bindDateChange(index)" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="item.date" style="width: 100%;">
                                    </el-date-picker>
                                    </el-col>
                                    <el-col class="line" :span="2" style="text-align:center">应付</el-col>
                                    <el-col :span="11">
                                    <el-input v-model="item.amount"  type='number' ></el-input>
                                    </el-col>
                                </el-form-item>

                                <el-form-item label="事件后">
                                    <el-col :span="11">
                                    <el-select  @change="bindDayconChange(item.daycon,index)"  v-model="item.daycon" style="width: 100%;">
                                        <el-option label="当日" value="mode1"></el-option>
                                        <el-option label="自然日" value="mode2"></el-option>
                                        <el-option label="工作日" value="mode3"></el-option>

                                    </el-select>
                                    
                                    </el-col>
                                    <el-col class="line" :span="2" style="text-align:center">天数</el-col>
                                    <el-col :span="11">
                                        <el-input v-model="item.daygap" @change="inputDayCon(item.daygap,index)"  type='number' ></el-input>
                                    </el-col>
                                </el-form-item>

                                <el-form-item label="支付期限">
                                    <el-col :span="11">
                                        <el-input v-model="item.payday" placeholder="无需输入，自动生成" disabled></el-input>
                                    </el-col>
                             
                                </el-form-item>


                            </div>


                        </div>

                        <el-form-item label="计息方式">
                            <el-col :span="11">
                            <el-select   v-model="param.ratio_mode" style="width: 100%;">
                                <el-option label="日息" value="day"></el-option>
                                <el-option label="月息" value="mon"></el-option>
                                <el-option label="年息" value="year"></el-option>
                                <el-option label="一年期lpr" value="lpr1"></el-option>
                                <el-option label="五年期lpr" value="lpr5"></el-option>

                            </el-select>
                            
                            </el-col>
                            <div v-if="param.ratio_mode!='lpr1' && param.ratio_mode!='lpr5'">
                                    <el-col class="line" :span="2" style="text-align:center">利率</el-col>
                                    <el-col :span="11">
                                        <el-input v-model="param.ratio"  type='number' ></el-input>
                                    </el-col>

                            </div>
                            <div v-else>
                                    <el-col class="line" :span="2" style="text-align:center">计息模式</el-col>

                                    <el-col :span="11">
                                        <el-select   v-model="param.lpr_method" style="width: 100%;">
                                            <el-option label="分段LPR（标准）" value="LPR"></el-option>
                                            <el-option label="平均LPR" value="avgLPR"></el-option>
                                            <el-option label="起始月LPR" value="firstLPR"></el-option>
                                            <el-option label="截至月LPR" value="lastLPR"></el-option>
                                            <el-option label="法定最高" value="maxLPR"></el-option>

                                        </el-select>
                                    </el-col>
                                
                                
                                
                            </div>
                          



                        </el-form-item>

                        <div class="contract_part">
                            <div  v-for="(item,ind) of param.pay" v-bind:key="ind">
                        

                                <el-form-item label="日期">
                                    <el-col :span="11" >
                                    <el-date-picker type="date"    placeholder="选择日期" v-model="item.date" style="width: 100%;" value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                    </el-col>
                                    <el-col class="line" :span="2" style="text-align:center">收款</el-col>
                                    <el-col :span="11">
                                    <el-input v-model="item.amount"></el-input>
                                    </el-col>
                                </el-form-item>

                            


                            </div>


                        </div>


                        



                    </el-form>

                    <div class="pay_node" style="padding-left:10px">签订《xxxx》合同</div>
                    <div class="breach_node" style="padding-left:10px">签订《xxxx》合同</div>
 

                

                </div>
            </div> -->
        </div>
	 
    </div>
</template>

<script>

import { IncUseNumber } from '@/assets/js/cal/cal'; 
 

 

function isphone() {
	var sUserAgent = navigator.userAgent.toLowerCase();
	var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
	var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
	var bIsMidp = sUserAgent.match(/midp/i) == "midp";
	var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
	var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
	var bIsAndroid = sUserAgent.match(/android/i) == "android";
	var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
	var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid
			|| bIsCE || bIsWM) {
		return true
	} else {
		return false
	}
}


function guid2() {  //
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (S4() + S4()  + S4()  + S4() +  S4() +  S4() + S4() + S4());
}
// var timestamp=new Date().getTime();
 
function random_str(number){
  return Math.random().toString(36).substr(2).slice(1,number+1)
}



 
// import affixbox from '@/components/yu/test.vue';   
// import pdf from 'vue-pdf'
import affix_box from '@/components/yu/affix_box.vue'

export default {
    name: 'visual', 
    components: {
        //  QRCode,
       affix_box

    },
 
	metaInfo: {
		title: '案件可视化',  
		meta: [{                 
			name: 'keywords',
			content: '可视化,项目管理'
		}],

    },
 
//   router,
   data() {
		return {
                param:{
                    cond:[
                        { event: ''  , daycon:'mode1', daygap:'' ,  amount:0 ,date: '', payday:''   }  // new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getDate()
                    ],   

                    ratio_mode:'day',
                    ratio:'',
                    lpr_method:'LPR',
                    endDate:'',
                    pay:[ {   amount:0 ,date: ''    }],
                    fileList:[
                        { 
                            fileLink: "https://sumai-lawfirm-oa.oss-cn-hangzhou.aliyuncs.com/oa/1689944933/01e62cb3f8ea805cb89e469a39996f17/委托代理合同.pdf",
                            fileName: "委托代理合同.pdf",
                            id: "2656232d-b43c-422b-928c-e4ad88a28500",
                            lastModified: 1695868072129,
                            name: "委托代理合同.pdf",
                            tempLink: "http://sumai-lawfirm-oa.oss-cn-hangzhou.aliyuncs.com/oa%2F1689944933%2F01e62cb3f8ea805cb89e469a39996f17%2F%E5%A7%94%E6%89%98%E4%BB%A3%E7%90%86%E5%90%88%E5%90%8C.pdf?OSSAccessKeyId=LTAI5tL4Q5Zi4sVqoDb7VVgi&Expires=1696159804&Signature=7BEhVImVa2wvj7d3G8Q7ddyvhs0%3D",
                            url: "http://sumai-lawfirm-oa.oss-cn-hangzhou.aliyuncs.com/oa%2F1689944933%2F01e62cb3f8ea805cb89e469a39996f17%2F%E5%A7%94%E6%89%98%E4%BB%A3%E7%90%86%E5%90%88%E5%90%8C.pdf?OSSAccessKeyId=LTAI5tL4Q5Zi4sVqoDb7VVgi&Expires=1696159804&Signature=7BEhVImVa2wvj7d3G8Q7ddyvhs0%3D",
                        }                
                    ],
                    imgList:[],
                   
          

                },

                cases:[ ],
                newCase:{ time:'',timestamp:'', title:'' ,attr:{}  },
                // isNewCase:false,
                currentIndex: '' ,
                isEdit:false,
		}
	},
	created(){
        this.isPhone=isphone()

 
	},
	mounted() {
        // IncUseNumber('ai_txt')
        this.GetToken()

	},
 
    methods: {
        
        timestampToTime(timestamp) {
            if(!timestamp){
                return ''
            }
            var date = new Date(timestamp  );//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            var D = date.getDate() + '';
            // var h = date.getHours() + ':';   //
            // var m = date.getMinutes() + ':';//
            // var s = date.getSeconds();//
            if (M.length==1){
                M='0' +M
            }
            if (D.length==1){
                D='0' +D
            }
            return Y + M + D ;  //+ h + m + s
        },
        NewLine(){
            // this.isNewCase=true 
            // this.newCase={ time:'',timestamp:'', title:'',attr:{}  }

            // tmp.unshift('c');
            // for(let p of this.cases){
            //     if(!p.timestamp){

            //     }
            // }

            this.cases.unshift({ time:'',timestamp:'', title:'',attr:{}  })
            this.isEdit=true
            this.currentIndex=0
            
        },
        CancleNewLine(){
            this.isNewCase=false 
            this.newCase={ time:'',timestamp:'', title:''  ,attr:{}  }
        
        },
        DeleteLine(){
            var that=this
            console.log('that.currentIndex:',that.currentIndex)
            this.$confirm('确定删除本段吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    console.log('that.currentIndex:',that.currentIndex)
                    // let obj=that.cases[that.currentIndex]
                    // delete that.cases[that.currentIndex].attr[part]
                    // delete that.cases[that.currentIndex][part]

                    this.$delete(that.cases,that.currentIndex)
                    // this.$delete(that.cases[that.currentIndex].attr,part)
                    
                    // console.log('that.cases:',that.cases)
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });    
                      
            });
        },
        DeleteModule(part){
            var that=this 
            this.$confirm('删除本行吗, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    console.log('that.currentIndex:',that.currentIndex)
                    // let obj=that.cases[that.currentIndex]
                    // delete that.cases[that.currentIndex].attr[part]
                    // delete that.cases[that.currentIndex][part]

                    this.$delete(that.cases[that.currentIndex],part)
                    this.$delete(that.cases[that.currentIndex].attr,part)
                    
                    console.log('that.cases:',that.cases)
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });    
                      
            });
        },
        
        AddContent(){
            console.log('AddContent')
            console.log('isEdit:',this.isEdit)
            console.log(this.cases[this.currentIndex])
            if(!this.cases[this.currentIndex].attr.content){
                console.log('===')
                // this.cases[this.currentIndex].attr.content=1
                this.$set( this.cases[this.currentIndex].attr , 'content', 1 )
                this.$set( this.cases[this.currentIndex] , 'content',  '' )
                // this.cases[this.currentIndex].content=''
            }

        },
        AddAffix(){
            if(!this.cases[this.currentIndex].attr.affix){
                console.log('===')
                // this.cases[this.currentIndex].attr.content=1
                this.$set( this.cases[this.currentIndex].attr , 'affix', 1 )
                this.cases[this.currentIndex].affix=[]
            }


        },
        ConfirmNewLine(){
            if(!this.newCase.timestamp || !this.newCase.title){
                this.$message({
                    message: '日期和标题内容不可为空哦',
                    type: 'warning',
                    duration:4000,
                    showClose:true,

                });
                return
            }
         
            console.log('newCase:',this.newCase)
            this.newCase.timestamp=this.newCase.timestamp
            this.cases.push(this.newCase)

            this.cases.sort(function(a, b) {
                return a.timestamp - b.timestamp; // 按照分数从高到低排序
            });

            this.newCase={ time:'',timestamp:'', title:'',attr:{}  }
            this.isNewCase=false 


        },
        ChooseItem(index){

            this.currentIndex=index

        },

        editMode(){
            this.isEdit=true 
            // this.cases[]


        },
        
        GetToken(){ 

			var that=this
			var datas= { 
				whattodo:'web_direct_private',
			}
			this.axios.post(this.$root.rootUrl+ 'mini_app',datas,{
				withCredentials:true,
			}
			).then(function (res) {
				// window.console.log(res)
				if(res.status==200){
					var result=res.data 
					if (result.status=='ok'){
						that.token=result.token
				 
					} 
					else if (result.status=='fail'){
						let failMsg=result.failMsg || '请先登录哦'
		
					} 
				}
				
			}).catch(function (error) {
				window.console.log(error);

			});



        },
        UpLoadFilesHandle(val){
			var that=this
			console.log('val1:',val)
			var file=val.file
			var filename=file.name
			// console.log("token:",token)
			var token=this.token || ''
			// if(!token){
			// 	this.get_token_and_UpLoadFiles(val)
			// }


			this.osspath=token.dir+ guid2()+ file.name   //文件地址
			this.fileName=filename

			// console.log(" this.osspath:",this.osspath)
			// console.log(" this.fileName:",this.fileName)


			let fd=new FormData()
			 
			fd.append("policy",token.policy);
			fd.append("OSSAccessKeyId",token.accessid);
			fd.append("signature",token.signature);
			fd.append("key",this.osspath);
	 
			fd.append("success_action_status",'200');
			fd.append("file", file);

			// console.log("----file:",file)

			const url = 'https://lawassist.oss-cn-hangzhou.aliyuncs.com'
			this.axios.post(url,fd,{ 
				withCredentials:false,
				headers: {"content-type": "multipart/form-data"},
				onUploadProgress: function (progressEvent) { //原生获取上传进度的事件
					// console.log('progressEvent:',progressEvent)
					if (progressEvent.lengthComputable) {

						that.uploadPercent=Math.floor( 100*progressEvent.loaded/progressEvent.total)
                        //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
                        //如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
                        // callback1(progressEvent);
                    }
                },
		
			},
			
			).then(function (res) {
				window.console.log(res)
				if(res.status==200){
					// var result=res.data
					that.$notify({
						title: '成功',
						message: '上传成功,点击开始转换开始转写工作。',
						type: 'success',
						duration: 7000
					});

					// that.start_tran(that.osspath)
					that.file_list.push(file)
					// console.log('=====file_list:',that.file_list)
					that.uploadSig=false
				}


				
			}).catch(function (error) {
				window.console.log(error);

			});


		 


		},



	 


        
	}
}



 
</script>

<style>
 
.visual_wrap{
    width: 100%;
    /* border: 1px solid #ad3131;  */
    display: flex;
    flex-direction: column;
    height: 100%;
}

.toolsbar{
    width: 100%;
    height: 80px;
    border-bottom: 1px solid #3163ad; 
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

}

.canvas{
    width: 100%;
    display: flex;
    flex-direction: column;
    /* border: 3px solid #d1b01b;  */
    height: calc(100% - 80px);  

}
.left_devide{
    position: absolute;
    /* left:1%; */
    height:calc(100% - 200px);    
    width: 30%;
    border-right: 1px dashed #c52519;
}
.timeline{
    width: 100%;
    margin:5px auto;
    border-bottom: 1px dashed #3163ad;  
    min-height: 80px;
    display: flex;
    flex-direction: row;

}

.l_part{
    width: 30%;
    /* border: 1px solid #3163ad;  */
    display: flex;
    flex-direction: column;
    /* justify-content: flex-end; */
    /* padding-right: 5px; */
 
}

.l_part_up{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}

.r_part{
    width: 70%;
    display: flex;
    flex-direction: column;
    /* border: 1px solid #3163ad;  */
 
}
.txt_node{
    
    font-size:20px;
    font-weight: bold;
    border: 1px solid #31ad50; 
    min-height: 30px;
    margin-top: 10px;
    /* line-height: ; */
    display: flex;
    flex-direction: row;
}
.subtxt_node{
    font-size: 17px;
    min-height: 30px;
    font-weight: 300; 
    padding-left: 10px;
    margin-top: 10px;

    display: flex;
    flex-direction: row;    

}

.affix_node{
    /* font-size: 17px; */
    min-height: 30px;
    /* font-weight: 300;  */
    padding-left: 10px;
    margin-top: 10px;

    display: flex;
    flex-direction: row;    
    /* align-items: center; */

}


.contract_part{
   border:1px dashed #3d2e2e;  
   padding: 20px;
}

.form_wrap{
    /* border:1px dashed #3d2e2e;  */
    width: 90%;
    /* padding: 20px; */
}

.btn_bar{
    width: 90%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    /* border:1px dashed #3d2e2e;   */
    margin-top: 15px;
    margin-bottom: 15px;

}
.bluespot{
    width:20px;
    height: 20px;
    /* border: 1px solid #333; */
}
</style>
 